import {
  DollarSign,
  Users,
  ShoppingBag,
  TrendingUp,
  ArrowUpRight,
  ArrowDownRight,
  Minus,
} from "lucide-react";

export default function StatCard({
  title,
  value,
  subtitle,
  icon,
  iconBg = "bg-gradient-to-br from-indigo-500 to-indigo-600",
  trend = "up",
}) {
  const trendStyles = {
    up: "bg-emerald-50 text-emerald-600",
    down: "bg-rose-50 text-rose-600",
    neutral: "bg-gray-100 text-gray-500",
  };

  const TrendIcon =
    trend === "up" ? ArrowUpRight : trend === "down" ? ArrowDownRight : Minus;

  return (
    <div className="group relative bg-white rounded-3xl p-6 border border-gray-100 shadow-sm hover:shadow-md hover:-translate-y-1 hover:border-gray-200 transition-all duration-300 ease-out overflow-hidden">

      {/* ambient glow */}
      <div
        className={`pointer-events-none absolute -top-12 -right-12 h-36 w-36 rounded-full ${iconBg} opacity-10 blur-2xl group-hover:opacity-20 transition-opacity duration-500`}
      />

      <div className="relative flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-gray-400">
            {title}
          </p>

          <h2 className="mt-3 text-3xl font-bold text-gray-900 tracking-tight tabular-nums">
            {value}
          </h2>

          {subtitle && (
            <div
              className={`mt-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${trendStyles[trend]}`}
            >
              <TrendIcon className="h-3.5 w-3.5" strokeWidth={2.5} />
              {subtitle}
            </div>
          )}
        </div>

        <div
          className={`relative shrink-0 h-14 w-14 rounded-2xl flex items-center justify-center ${iconBg} group-hover:scale-105 group-hover:-rotate-3 transition-transform duration-300 ease-out`}
        >
          <div className="text-white">{icon}</div>
        </div>
      </div>
    </div>
  );
}